module.exports = __webpack_public_path__ + "img/DUH.908627df.png";